import type { OtelProvider } from './open-telemetry.interfaces';

// Никаких импорта из @opentelemetry/*
export type OpenTelemetryProviderLike = OtelProvider | null;

let providerRef: OpenTelemetryProviderLike = null;
let providerPromise: Promise<OpenTelemetryProviderLike> | null = null;
let providerResolve: ((provider: OpenTelemetryProviderLike) => void) | null = null;

export function setOpenTelemetryProvider(provider: OpenTelemetryProviderLike): void {
  providerRef = provider;
  if (providerResolve) {
    providerResolve(provider);
    providerResolve = null;
  }
}

export function getOpenTelemetryProvider(): OpenTelemetryProviderLike {
  return providerRef;
}

export function getOpenTelemetryProviderAsync(): Promise<OpenTelemetryProviderLike> {
  if (providerRef) {
    return Promise.resolve(providerRef);
  }

  if (!providerPromise) {
    providerPromise = new Promise<OpenTelemetryProviderLike>((resolve) => {
      providerResolve = resolve;
    });
  }

  return providerPromise;
}
